import { Outlet, createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '../../components';

const FeedLayout = () => (
  <PageContainer>
    <Outlet />
  </PageContainer>
);

export const Route = createFileRoute('/_auth/_feed')({
  component: FeedLayout,
});
